/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminInterestRegistrationRepresentative
 */
export interface AdminInterestRegistrationRepresentative {
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    readonly user?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    readonly url?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminInterestRegistrationRepresentative
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminInterestRegistrationRepresentative
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    role?: AdminInterestRegistrationRepresentativeRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInterestRegistrationRepresentative
     */
    phoneNumber?: string | null;
}


/**
 * @export
 */
export const AdminInterestRegistrationRepresentativeRoleEnum = {
    Manager: 'Manager',
    Accountant: 'Accountant',
    Lawyer: 'Lawyer',
    Representative: 'Representative',
    Company: 'Company'
} as const;
export type AdminInterestRegistrationRepresentativeRoleEnum = typeof AdminInterestRegistrationRepresentativeRoleEnum[keyof typeof AdminInterestRegistrationRepresentativeRoleEnum];


/**
 * Check if a given object implements the AdminInterestRegistrationRepresentative interface.
 */
export function instanceOfAdminInterestRegistrationRepresentative(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AdminInterestRegistrationRepresentativeFromJSON(json: any): AdminInterestRegistrationRepresentative {
    return AdminInterestRegistrationRepresentativeFromJSONTyped(json, false);
}

export function AdminInterestRegistrationRepresentativeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminInterestRegistrationRepresentative {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        'name': json['name'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phone_number') ? undefined : json['phone_number'],
    };
}

export function AdminInterestRegistrationRepresentativeToJSON(value?: AdminInterestRegistrationRepresentative | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'role': value.role,
        'email': value.email,
        'phone_number': value.phoneNumber,
    };
}

